import { type RouteRecordRaw } from 'vue-router';

export const integrationsRoutes: RouteRecordRaw[] = [
  {
    path: '/auth/google-sheets/callback',
    name: 'google-sheets-callback',
    component: () => import('@bv/pages/integrations/GoogleSheetsCallback.vue'),
    meta: {
      title: 'Google Sheets - Connected',
      public: true, // using 'public' as defined in RouteGuardMeta for @bv
    },
  },
];
